import { useState, useEffect } from "react";
import DynamicDataGrid from "../components/DynamicDataGrid";
import NavAppBar from "../components/NavAppBar"
import { useAuth } from "../context/AuthProvider"
import dataService from "../services/Data"
import { Container, CssBaseline, Grid, Box } from "@mui/material"
import { useNavigate } from "react-router-dom";
import CustomDialog from "../components/CustomDialog";

export const Datos = () => {
    const { user } = useAuth()
    const [rowsVehiculo, setRowsVehiculo] = useState([]);
    const [columnsVehiculo, setColumnsVehiculo] = useState([]);
    const [rowsCredito, setRowsCredito] = useState([]);
    const [columnsCredito, setColumnsCredito] = useState([]);
    const [rowsModelo, setRowsModelo] = useState([]);
    const [columnsModelo, setColumnsModelo] = useState([]);
    const [rowsPlazo, setRowsPlazo] = useState([]);
    const [columnsPlazo, setColumnsPlazo] = useState([]);
    const [rowsVinculacion, setRowsVinculacion] = useState([]);
    const [columnsVinculacion, setColumnsVinculacion] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [msjError, setMostrarMsjError] = useState(false)

    const [isRedirect, setIsRedirect] = useState(false)

    // Definición de columnas
    const columnVehiculo = [{ field: 'vehiculoID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'nombre', headerName: 'VEHICULO', width: 220, align: 'left', editable: true, required: true }, { field: 'activo', headerName: 'ACTIVO', width: 80, align: 'center', editable: true, type: 'boolean' }, { field: 'adelantamientoCuota', headerName: 'ADEL. CUOTA', width: 120, align: 'center', editable: true, type: 'boolean' }];
    const columnCredito = [{ field: 'tipoCreditoID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'nombre', headerName: 'TIPO CREDITO', width: 220, align: 'left', editable: true, required: true }, { field: 'activo', headerName: 'ACTIVO', width: 80, align: 'center', editable: true, type: 'boolean' }];
    const columnModelo = [{ field: 'modeloID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'nombre', headerName: 'NOMBRE', width: 220, align: 'left', editable: true, required: true }, { field: 'activo', headerName: 'ACTIVO', width: 80, align: 'center', editable: true, type: 'boolean' }];
    const columnPlazo = [{ field: 'plazoID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'nombre', headerName: 'NOMBRE', width: 220, align: 'left', editable: true, required: true }, { field: 'activo', headerName: 'ACTIVO', width: 80, align: 'center', editable: true, type: 'boolean' }];
    let navigate = useNavigate();
    let columnVinculacion = null;
    dataService.setToken(user.data.token)
    // Cargar datos iniciales
    useEffect(() => {
        try {
            setLoading(true);
            setColumnsVehiculo(columnVehiculo);
            dataService.listarVehiculos(setRowsVehiculo, true);

            setColumnsCredito(columnCredito);
            dataService.listarCreditos(setRowsCredito, true);

            setColumnsModelo(columnModelo);
            dataService.listarModelos(setRowsModelo);

            setColumnsPlazo(columnPlazo);
            dataService.listarPlazos(setRowsPlazo);

            dataService.listarVehiculosTiposCredModelos(setRowsVinculacion)
        } catch (err) {
            setError('Error al cargar los datos');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    //const columnVinculacion = [{ field: 'vehiculoTipoCreditoModeloID', headerName: 'ID', width: 60, align: 'center', editable: false }, { field: 'vehiculo', headerName: 'VEHICULO', width: 120, align: 'left', editable: true }, { field: 'modelo', headerName: 'MODELO', width: 100, align: 'left', editable: true },
    //{
    //    field: 'tipoCreditoID',
    //    headerName: 'TIPO CREDITO',
    //    width: 150,
    //    editable: true,
    //    type: 'singleSelect',
    //    valueOptions: rowsCredito, // Opciones dinámicas
    //},
    //{ field: 'tipoCredito', headerName: 'TIPO CREDITO', width: 200, align: 'left', editable: true }];

    useEffect(() => {
        (() => {
            columnVinculacion = [
                //{ field: 'vehiculo', headerName: 'VEHICULO', width: 120, align: 'left', editable: true },
                //{ field: 'modelo', headerName: 'MODELO', width: 100, align: 'left', editable: true },
                { field: 'vehiculoTipoCreditoModeloID', headerName: 'ID', width: 60, align: 'center', editable: false },
                {
                    field: 'vehiculoID',
                    headerName: 'VEHICULO',
                    width: 150,
                    editable: true,
                    type: 'singleSelect',
                    valueOptions: rowsVehiculo.filter((vehiculo) => vehiculo.activo).map((vehiculo) => ({
                        value: vehiculo.vehiculoID, // Valor que se guarda en la fila
                        label: vehiculo.nombre, // Texto que se muestra en el desplegable
                    })),
                    required: true
                },
                {
                    field: 'tipoCreditoID',
                    headerName: 'TIPO CREDITO',
                    width: 160,
                    editable: true,
                    type: 'singleSelect',
                    valueOptions: rowsCredito.filter((credito) => credito.activo).map((credito) => ({
                        value: credito.tipoCreditoID, // Valor que se guarda en la fila
                        label: credito.nombre, // Texto que se muestra en el desplegable
                    })),
                    required: true
                },
                {
                    field: 'modeloID',
                    headerName: 'MODELO',
                    width: 180,
                    editable: true,
                    type: 'singleSelect',
                    valueOptions: rowsModelo.filter((modelo) => modelo.activo).map((modelo) => ({
                        value: modelo.modeloID, // Valor que se guarda en la fila
                        label: modelo.nombre, // Texto que se muestra en el desplegable
                    })),
                    required: true
                }];

            setColumnsVinculacion(columnVinculacion);
        })()
    }, ([rowsVehiculo, rowsCredito, rowsModelo]))

    useEffect(() => {
        (() => {
            if (isRedirect) {
                navigate("/datos");
            }
        })()
    }, [isRedirect])

    // Handlers CRUD Vehículo
    const handleCreateVehiculo = async (newRow) => {
        try {
            if (rowsVehiculo.filter(item => item.nombre === newRow.nombre).length > 0) {
                setError('Ya existe otro vehículo con el nombre ingresado.');
                setMostrarMsjError(true);
                return;
            }
            const response = await dataService.insertarVehiculo(newRow)
            setRowsVehiculo([...rowsVehiculo, response]);
            //setIsRedirect(true)
            //return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdateVehiculo = async (updatedRow) => {
        try {
            const response = await dataService.actualizarVehiculo(updatedRow.vehiculoID, updatedRow)
            setRowsVehiculo(rowsVehiculo.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDeleteVehiculo = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    // Handlers CRUD Crédito
    const handleCreateCredito = async (newRow) => {
        try {
            if (rowsCredito.filter(item => item.nombre === newRow.nombre).length > 0) {
                setError('Ya existe otro tipo de crédito con el nombre ingresado.');
                setMostrarMsjError(true);
                return;
            }
            const response = await dataService.insertarCredito(newRow)
            setRowsCredito([...rowsCredito, response]);
            return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdateCredito = async (updatedRow) => {
        try {
            const response = await dataService.actualizarCredito(updatedRow.tipoCreditoID, updatedRow)
            setRowsCredito(rowsCredito.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDeleteCredito = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    // Handlers CRUD Modelo
    const handleCreateModelo = async (newRow) => {
        try {
            if (rowsModelo.filter(item => item.nombre === newRow.nombre).length > 0) {
                setError('Ya existe otro modelo con el nombre ingresado.');
                setMostrarMsjError(true);
                return;
            }
            const response = await dataService.insertarModelo(newRow)
            setRowsModelo([...rowsModelo, response]);
            return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdateModelo = async (updatedRow) => {
        try {
            const response = await dataService.actualizarModelo(updatedRow.modeloID, updatedRow)
            setRowsModelo(rowsModelo.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDeleteModelo = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    // Handlers CRUD Plazo
    const handleCreatePlazo = async (newRow) => {
        try {
            if (rowsPlazo.filter(item => item.nombre === newRow.nombre).length > 0) {
                setError('Ya existe otro plazo con el nombre ingresado.');
                setMostrarMsjError(true);
                return;
            }
            const response = await dataService.insertarPlazo(newRow)
            setRowsPlazo([...rowsPlazo, response]);
            return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdatePlazo = async (updatedRow) => {
        try {
            const response = await dataService.actualizarPlazo(updatedRow.PlazoID, updatedRow)
            setRowsPlazo(rowsPlazo.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDeletePlazo = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    // Handlers CRUD Vinculacion
    const handleCreateVinculacion = async (newRow) => {
        try {
            if (rowsVinculacion.filter(item => item.vehiculoID === newRow.vehiculoID && item.tipoCreditoID === newRow.tipoCreditoID && item.modeloID === newRow.modeloID).length > 0) {
                setError('Ya existe la vinculación que esta intentando ingresar.');
                setMostrarMsjError(true);
                return;
            }
            const response = await dataService.insertarVehiculoTipoCredModelo(newRow)
            setRowsVinculacion([...rowsVinculacion, response]);
            return response;
        } catch (err) {
            setError('Error al crear el registro');
            console.error(err);
            throw err;
        }
    };

    const handleUpdateVinculacion = async (updatedRow) => {
        try {
            const response = await dataService.actualizarVehiculoTipoCredModelo(updatedRow.vehiculoTipoCreditoModeloID, updatedRow)
            setRowsVinculacion(rowsVinculacion.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            console.error(err);
            throw err;
        }
    };

    const handleDeleteVinculacion = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            console.error(err);
            throw err;
        }
    };

    //if (loading) return <div>Cargando...</div>;
    //if (error) return <div>{error}</div>;

    return (
        <>
            {!msjError ? "" : <CustomDialog message={error} btnText="OK" title="Aviso" state={setMostrarMsjError} open={msjError} />}
            <CssBaseline />
            <NavAppBar />
            <Container style={{ maxWidth: 600 }} >
                {rowsVehiculo != null ? (
                    <>
                        <Box display="flex" justifyContent="center" margin="dense">
                            <h2>Vehiculos</h2>
                        </Box>
                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                hideFootInfo={true}
                                rows={rowsVehiculo}
                                columns={columnsVehiculo}
                                onCreate={handleCreateVehiculo}
                                onUpdate={handleUpdateVehiculo}
                                onDelete={handleDeleteVehiculo}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}

                {rowsCredito != null ? (
                    <>
                        <Box display="flex" justifyContent="center" margin="dense">
                            <h2>Tipos Cr&eacute;ditos</h2>
                        </Box>
                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                hideFootInfo={true}
                                rows={rowsCredito}
                                columns={columnsCredito}
                                onCreate={handleCreateCredito}
                                onUpdate={handleUpdateCredito}
                                onDelete={handleDeleteCredito}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}

                {rowsModelo != null ? (
                    <>
                        <Box display="flex" justifyContent="center" margin="dense">
                            <h2>Modelos</h2>
                        </Box>

                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                hideFootInfo={true}
                                rows={rowsModelo}
                                columns={columnsModelo}
                                onCreate={handleCreateModelo}
                                onUpdate={handleUpdateModelo}
                                onDelete={handleDeleteModelo}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}

                {rowsPlazo != null ? (
                    <>
                        <Box display="flex" justifyContent="center" margin="dense">
                            <h2>Plazos</h2>
                        </Box>

                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                hideFootInfo={true}
                                rows={rowsPlazo}
                                columns={columnsPlazo}
                                onCreate={handleCreatePlazo}
                                onUpdate={handleUpdatePlazo}
                                onDelete={handleDeletePlazo}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}

                {rowsVinculacion != null ? (
                    <>
                        <Box display="flex" justifyContent="center" margin="dense">
                            <h2>Vinculaciones</h2>
                        </Box>

                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                hideFootInfo={true}
                                rows={rowsVinculacion}
                                columns={columnsVinculacion}
                                onCreate={handleCreateVinculacion}
                                onUpdate={handleUpdateVinculacion}
                                onDelete={handleDeleteVinculacion}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}
            </Container>
        </>
    );
};